import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * `app-jems-textarea` — campo de texto multi-linha NATIVO do JEMS3, análogo ao
 * `app-jems-select`: um `<textarea>` puro com o chrome JEMS3 (caixa com borda que
 * engrossa no hover e vira accent no foco), SEM `mat-form-field`/Material — nada
 * de remendar internos do Material com `::ng-deep`.
 *
 * Contrato de `[formGroupController]` + `name` (lê/escreve o FormControl direto,
 * como o `app-jems-select`), então é drop-in do `app-multiline-text-input`:
 * `[placeholder]`, `[maxLength]`, `[readOnly]`, `[required]`, `[description]`.
 * `[rows]` virou `[minRows]` (autosize cresce a partir daí).
 */
@Component({
  selector: 'app-jems-textarea',
  templateUrl: './jems-textarea.component.html',
  styleUrls: ['./jems-textarea.component.scss'],
})
export class JemsTextareaComponent {
  @Input() formGroupController: FormGroup;
  @Input() name: string;
  /** Texto do placeholder JÁ traduzido (mesmo contrato do multiline-text-input). */
  @Input() placeholder = '';
  /** Chave i18n do rótulo acima da caixa (traduzida aqui). Opcional. */
  @Input() description?: string;
  @Input() required = false;
  @Input() readOnly = false;
  @Input() maxLength?: number;
  /** Nº mínimo de linhas visíveis; o autosize cresce a partir daí. */
  @Input() minRows = 5;
  /** Teto opcional de linhas (autosize para de crescer e passa a rolar). */
  @Input() maxRows?: number;

  get control(): AbstractControl | null {
    return this.formGroupController?.get(this.name) ?? null;
  }

  get value(): string {
    return this.control?.value ?? '';
  }

  /** Só exibe erro após interação (touched/dirty) — mesma UX que o Material tinha. */
  get showError(): boolean {
    const c = this.control;
    return !!c && c.invalid && (c.touched || c.dirty);
  }

  hasError(code: string): boolean {
    return !!this.control?.hasError(code);
  }
}
